/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Description',
    END_DATE: 'Jusqu\'à',
    ID: 'ID',
    OBJECTIVE: 'Objectif',
    REWARD: 'Récompense',
    START_DATE: 'Le'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Montant accumulé',
    ACTIVES: 'Actifs',
    AT: 'Le',
    COUPON: 'Coupon',
    CREATED: 'Créé',
    DAY_VALUE: 'Montant du jour',
    FAIL: 'Échec',
    FINISHED: 'Terminé',
    HISTORY: 'Historique',
    IN_PROGRESS: 'En cours',
    MONETARY_REWARD: 'Récompense',
    NR_ACCESSES: 'Nouveaux accès',
    NR_NEW_CLIENTS: 'Nouveaux clients',
    NR_ORDERS: 'Commandes',
    OBJECTIVE: 'Objectif',
    OBJECTIVE_VALUE: 'Montant de l\'objectif',
    OFFER: 'Offre',
    OPEN: 'Ouvrir',
    REMUNERATION: 'Rémunération',
    REWARD_TYPE: 'Type de récompense',
    REWARD_TYPES: 'Types de récompense',
    SALES: 'Ventes',
    SALES_BRANDS: 'Gammes de vente (€)',
    SALES_BRANDS_QTY: 'Gammes de vente (Qté)',
    SALES_CATEGORY: 'Catégorie de vente (€)',
    SALES_CATEGORY_QTY: 'Catégorie de vente (Qté)',
    SALES_COMMISSIONS: 'Commissions de vente',
    SALES_PRODUCTS: 'Produits à vendre (€)',
    SALES_PRODUCTS_QTY: 'Produits à vendre (Qté)',
    SUCCESS: 'Succès',
    TO: '{0} à {1}',
    TODAY: 'Aujourd\'hui'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'Aucun challenge actif (pour l\'instant).',
    CHALLANGES_TITLE: 'Aucun challenge.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
